export default "__VITE_ASSET__BqBZnCvZ__"